import RevertToDraft from './RevertToDraft';

interface ISummaryReportActionsProps {
  teamId: string,
  campaignId: string,
  iterationId: string,
}

function SummaryReportActions({ campaignId, iterationId, teamId }: ISummaryReportActionsProps) {
  return (
    <RevertToDraft campaignId={campaignId} iterationId={iterationId} teamId={teamId} />
  );
}

export default SummaryReportActions;
